var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cc-4-l widget-simple-text"},[(_vm.loading)?_c('div',{staticClass:"cc-loader"},[_c('div',{staticClass:"spinner"})]):_c('div',[_c('span',{staticClass:"cc-block cc-fs-50"},[_vm._v(_vm._s(_vm.currentDate))]),_c('span',{staticClass:"cc-block cc-fs-75 cc-fw-700"},[_vm._v(_vm._s(_vm.currentHours))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }